import { DestroyRef } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { Params } from '@angular/router';
import { debounceTime, distinctUntilChanged, Subject } from 'rxjs';
import { QueryParamsService } from '../services/query-params.service';
import { QueryParamCodecs, readQueryParamState, stringParam, toQueryParams } from './query-param-state.util';

export const SEARCH_DEBOUNCE_IN_MS = 500;

export interface SearchUrlState {
    search: string;
}

const codecs: QueryParamCodecs<SearchUrlState> = {
    search: stringParam('q')
};

export const readSearchTerm = (params: Params): string => readQueryParamState(codecs, params).search;

export const toSearchQueryParams = (state: SearchUrlState) => toQueryParams(codecs, state);

/**
 * Debounces the URL write for pages that filter on every keystroke: WebKit throttles `history.replaceState` after
 * 100 calls in 30 seconds, and the rejected navigation is swallowed, so an undebounced URL silently stops following.
 */
export const createSearchUrlWriter = (queryParams: QueryParamsService, destroyRef: DestroyRef): ((search: string) => void) => {
    const searchUpdates = new Subject<string>();

    searchUpdates
        .pipe(debounceTime(SEARCH_DEBOUNCE_IN_MS), distinctUntilChanged(), takeUntilDestroyed(destroyRef))
        .subscribe((search) => queryParams.write(toSearchQueryParams({ search })));

    return (search) => searchUpdates.next(search);
};
